import { useParams } from 'react-router-dom';
import ButtonIcon from 'components/ButtonIcon';
import Trash from 'components/icons/trash';
import { Customer } from 'data/firestore/agent/customer/types';
import useManageCustomers from 'data/hooks/useManageCustomers';
import { ActionsCellWrapper } from './styled';

interface Props {
    row?: Customer;
}

const ActionsColumn = ({
    row = {} as Customer,
}: Props) => {
    const { agentId = '' } = useParams();
    const { remove } = useManageCustomers({ agentId });
    return (
        <ActionsCellWrapper>
            <ButtonIcon
                borderRadius="semi-square"
                icon={<Trash />}
                tooltip="Remove customer"
                size="small"
                onClick={() => remove(row?.id)}
            />
        </ActionsCellWrapper>
    );
};

export default ActionsColumn;
